import { render, staticRenderFns } from "./LeadPostpone.vue?vue&type=template&id=1f965c80"
import script from "./LeadPostpone.vue?vue&type=script&lang=js"
export * from "./LeadPostpone.vue?vue&type=script&lang=js"
import style0 from "./LeadPostpone.vue?vue&type=style&index=0&id=1f965c80&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports